import { render, staticRenderFns } from "./tradeLedger.vue?vue&type=template&id=80b15658&scoped=true&"
import script from "./tradeLedger.vue?vue&type=script&lang=js&"
export * from "./tradeLedger.vue?vue&type=script&lang=js&"
import style0 from "./tradeLedger.vue?vue&type=style&index=0&id=80b15658&prod&scoped=true&lang=css&"
import style1 from "./tradeLedger.vue?vue&type=style&index=1&id=80b15658&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b15658",
  null
  
)

export default component.exports